import { User } from '@v2/shared/lib/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { faUser as falUser } from '@fortawesome/pro-light-svg-icons';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

type Props = {
  user: User;
};

export default function AccountOverview({ user }: Props) {
  const { buildUrl } = useUrlGenerator();

  return (
    <a href={buildUrl('/customer?xCmd=account')} className="group flex items-center justify-between mb-4">
      <div className="flex items-center flex-grow">
        <div className="h-12 w-12 sm:h-16 sm:w-16 rounded-full bg-slate-100 group-hover:bg-slate-200 group-active:bg-slate-300 flex items-center justify-center text-slate-400 group-hover:text-slate-700 group-active:text-slate-800 text-2xl mr-3">
          <FontAwesomeIcon icon={falUser} className="text-lg sm:text-xl" />
        </div>
        <div className="flex flex-col flex-grow">
          <div className="font-semibold">{user.name.first_name}</div>
          <div className="text-sm font-medium text-slate-500 group-hover:text-slate-700 group-active:text-slate-900 truncate w-[230px]">
            {user.email}
          </div>
        </div>
        <span className="mr-3">
          <FontAwesomeIcon
            icon={faAngleRight}
            className="text-slate-400 mr-1 group-hover:text-slate-900 group-active:text-slate-900 text-lg"
          />
        </span>
      </div>
    </a>
  );
}
